// extracted by mini-css-extract-plugin
export default {"fixedMobileCTAContainer":"G93e64a","ctaContainer":"Gd5ab09"};